// removed by extract-text-webpack-plugin
module.exports = {"Select-animation-fadeIn":"virtualized-select__Select-animation-fadeIn___JaSwB","Select-animation-spin":"virtualized-select__Select-animation-spin___1iZDv"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/virtualized-select.scss
// module id = 1375
// module chunks = 0